import * as yup from 'yup'

export const addPurchaseInvoiceValidation = yup.object({
    seller_name: yup.string().required("Please enter seller name!"),
    item_name: yup.string().required("Please enter item name!"),
    invoice_total: yup.string().required("Please enter invoice amount!"),
    gst_amount: yup.string().required("Please enter gst amount!"),
    purchase_date: yup.date().required("Please select date!"),
})